// LanguageCard — surface inside /account that lets the user change app language.
// Saves to backend via PATCH /api/auth/me (preferences.language).
import React from "react";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../contexts/LanguageContext";

const LanguageCard = () => {
    const { t } = useTranslation();
    const { lang, setLang, languages } = useLanguage();

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-soft" data-testid="account-language-card">
            <div className="flex items-center gap-3">
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand-50 text-brand-700">
                    <Globe className="h-5 w-5" />
                </div>
                <div>
                    <p className="label-uppercase">{t("Language")}</p>
                    <h2 className="text-lg font-semibold tracking-tight text-zinc-900">{t("Choose your language")}</h2>
                    <p className="text-xs text-slate-500">{t("PILLS")} · 13 {t("Language").toLowerCase()}</p>
                </div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4" data-testid="account-language-grid">
                {languages.map((l) => (
                    <button
                        key={l.code}
                        type="button"
                        onClick={() => setLang(l.code)}
                        className={`flex items-center gap-2 rounded-xl border px-3 py-2.5 text-left text-sm transition-colors ${
                            lang === l.code
                                ? "border-brand-500 bg-brand-50 text-brand-800 ring-1 ring-brand-200"
                                : "border-zinc-200 bg-white text-zinc-700 hover:border-brand-300 hover:bg-brand-50/40"
                        }`}
                        data-testid={`account-language-${l.code}`}
                    >
                        <span className="text-lg leading-none">{l.flag_emoji}</span>
                        <span className="flex flex-col">
                            <span className="font-medium leading-tight">{l.native_name}</span>
                            <span className="text-[10px] text-zinc-500 leading-tight">{l.name}</span>
                        </span>
                    </button>
                ))}
            </div>
        </section>
    );
};

export default LanguageCard;
